import React, { useContext } from "react";
import DescriptionIcon from "@material-ui/icons/Description";

import SemImagemSmall from "../../../../assets/images/sem-imagem-small.jpg";
import { statusTypes } from "containers/PeopleCraft/ContentPage/StatusTypes";
import { FaRegEdit } from "react-icons/fa";
import { FiTrash2 } from "react-icons/fi";
import { CircularProgress } from "@material-ui/core";
import { LMCreateContext } from "containers/PeopleCraft/LearningManagementNew/Contexts/LMContext";

export const PreTestCard = ({
  element,
  permissionLearningPage,
  idBlock,
  noEditPermition,
  handleEditElementRedirect,
  loadingDeleteBlockElement,
  removeNode,
}) => {
  const { nodeData } = useContext(LMCreateContext);

  return (
    <>
      <div className="node-manager-content-type-article-wrapper" style={{ boxShadow: "none" }}>
        <img
          alt="article"
          className="node-manager-content-type-article-image"
          src={element.data?.image || SemImagemSmall}
        />
        <div className="node-manager-content-type-article-container-v2" style={{
          boxShadow: 'none'
        }}>
          <div
            style={{
              fontSize: 18,
              fontWeight: "bold",
              marginBottom: 5,
            }}
          >
            {element.data?.title}
          </div>

          <div style={{ display: "flex" }}>
            <DescriptionIcon style={{ color: "#6b48ff", fontSize: 22, marginRight: 5 }} />
            <span style={{ color: "#a3a3a3", marginTop: 2 }}>Pré-teste de conhecimento</span>
          </div>
          <span
            style={{
              color: "#6E44FF",
              textAlign: "left",
              font: "normal normal bold 13px/16px SF Pro Text",
              letterSpacing: 0.13,
              opacity: 1,
              marginTop: 10
            }}
          >
            O pré-teste é obrigatório e será a primeira etapa ao acessar a página. O conteúdo só
            será liberado após a conclusão da avaliação.
          </span>
        </div>
      </div>
      <div className="node-manager-node-item-actions-container">
        <div
          className={`node-manager-node-item-actions ${
            noEditPermition(element, nodeData) ? "" : "node-purple"
          }`}
          onClick={() => handleEditElementRedirect(element, nodeData)}
          style={{
            pointerEvents: noEditPermition(element, nodeData) ? "none" : "auto",
          }}
        >
          <span style={{ color: noEditPermition(element, nodeData) ? "grey" : "black" }}>
            Editar
          </span>
          <FaRegEdit style={{ fontSize: 22 }} />
        </div>
        <div
          className={`node-manager-node-item-actions ${
            ([statusTypes.ARCHIVED, statusTypes.PUBLISHED].includes(nodeData?.status) &&
              nodeData?.nodeType !== "ORGANIZATION") ||
            !permissionLearningPage
              ? ""
              : "node-red"
          }`}
          onClick={() => removeNode(element)}
          style={{
            pointerEvents:
              ([statusTypes.ARCHIVED, statusTypes.PUBLISHED].includes(nodeData?.status) &&
                nodeData?.nodeType !== "ORGANIZATION") ||
              !permissionLearningPage ||
              loadingDeleteBlockElement
                ? "none"
                : "auto",
          }}
        >
          <span
            style={{
              color:
                ([statusTypes.ARCHIVED, statusTypes.PUBLISHED].includes(nodeData?.status) &&
                  nodeData?.nodeType !== "ORGANIZATION") ||
                !permissionLearningPage
                  ? "grey"
                  : "black",
            }}
          >
            Remover
          </span>
          {loadingDeleteBlockElement === element.idBlockElement ? (
            <CircularProgress size={22} />
          ) : (
            <FiTrash2 style={{ fontSize: 22 }} />
          )}
        </div>
      </div>
    </>
  );
};
